import { req } from 'react-reqq-lite';

export const get = ({ key, transform, duration = 200 }) => {
  req.set(`LOADING/get/${key}`, true);
  setTimeout(() => {
    if (typeof transform === 'function') req.set(key, transform());
    req.set(`LOADING/get/${key}`, false);
  }, duration);
};

export const post = ({ key, onSuccess, duration = 200 }) => {
  req.set(`LOADING/get/${key}`, true);
  setTimeout(() => {
    if (typeof onSuccess === 'function') onSuccess();
    req.set(`LOADING/get/${key}`, false);
  }, duration);
};

export const put = ({ key, onSuccess, duration = 200 }) => {
  req.set(`LOADING/get/${key}`, true);
  setTimeout(() => {
    if (typeof onSuccess === 'function') onSuccess();
    req.set(`LOADING/get/${key}`, false);
  }, duration);
};

export const remove = ({ key, onSuccess, duration = 200 }) => {
  req.set(`LOADING/get/${key}`, true);
  setTimeout(() => {
    if (typeof onSuccess === 'function') onSuccess();
    req.set(`LOADING/get/${key}`, false);
  }, duration);
};
